// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.col-news {
  background-color: #ffffff;
  width: 90%;
  border-radius: 12px;
  padding: 0 !important;
}

.row-news {
  display: flex;
  justify-content: space-around;
  justify-content: space-around;
  align-items: center;
  gap: 1rem;
}

.news-image {
  height: 250px;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  object-fit: cover;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.news-container {
  height: 100%;
  padding: 0;
  background-color: #ffffff;
  border-radius: 12px;
}

.news-head {
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 14px;
  letter-spacing: 0px;
  color: #777776;
  opacity: 1;
}

.news-content {
  display: flex;
  align-items: flex-start;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px 20px 0px 20px;
}

.news-title {
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 20px;
  letter-spacing: 0px;
  color: #4e7da2;
  opacity: 1;
  min-width: 220px;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 80px;
  font-size: 18px;
  line-height: 1.7rem;
}`, "",{"version":3,"sources":["webpack://./src/sass/layout/features-news/features-news.scss","webpack://./src/sass/layout/features-news/features-news.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAGA;EACE,yBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;ACFF;;ADKA;EACE,aAAA;EACA,6BAAA;EACA,6BAAA;EACA,mBAAA;EACA,SAAA;ACFF;;ADKA;EACE,aAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,iBAAA;EACA,4BAAA;EACA,6BAAA;ACFF;;ADIA;EACE,YAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;ACDF;;ADGA;EACE,gBAAA;EACA,0CElCK;EFmCL,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;ACAF;;ADGA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;ACAF;;ADEA;EACE,gBAAA;EACA,0CEnDK;EFoDL,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;ACCF","sourcesContent":["@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.col-news {\n  background-color: #ffffff;\n  width: 90%;\n  border-radius: 12px;\n  padding: 0 !important;\n}\n\n.row-news {\n  display: flex;\n  justify-content: space-around;\n  justify-content: space-around;\n  align-items: center;\n  gap: 1rem;\n}\n\n.news-image {\n  height: 250px;\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  object-fit: cover;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n.news-container {\n  height: 100%;\n  padding: 0;\n  background-color: #ffffff;\n  border-radius: 12px;\n}\n.news-head {\n  text-align: left;\n  font-family: $Font;\n  font-size: 14px;\n  letter-spacing: 0px;\n  color: #777776;\n  opacity: 1;\n  // margin: 0.5rem 0rem 0.5rem 1.5rem;\n}\n.news-content {\n  display: flex;\n  align-items: flex-start;\n  align-content: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 10px 20px 0px 20px;\n}\n.news-title {\n  text-align: left;\n  font-family: $Font;\n  font-size: 20px;\n  letter-spacing: 0px;\n  color: #4e7da2;\n  opacity: 1;\n  min-width: 220px;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 80px;\n  font-size: 18px;\n  line-height: 1.7rem;\n}\n",".col-news {\n  background-color: #ffffff;\n  width: 90%;\n  border-radius: 12px;\n  padding: 0 !important;\n}\n\n.row-news {\n  display: flex;\n  justify-content: space-around;\n  justify-content: space-around;\n  align-items: center;\n  gap: 1rem;\n}\n\n.news-image {\n  height: 250px;\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  -o-object-fit: cover;\n     object-fit: cover;\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n\n.news-container {\n  height: 100%;\n  padding: 0;\n  background-color: #ffffff;\n  border-radius: 12px;\n}\n\n.news-head {\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 14px;\n  letter-spacing: 0px;\n  color: #777776;\n  opacity: 1;\n}\n\n.news-content {\n  display: flex;\n  align-items: flex-start;\n  align-content: center;\n  justify-content: center;\n  flex-direction: column;\n  padding: 10px 20px 0px 20px;\n}\n\n.news-title {\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 20px;\n  letter-spacing: 0px;\n  color: #4e7da2;\n  opacity: 1;\n  min-width: 220px;\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  height: 80px;\n  font-size: 18px;\n  line-height: 1.7rem;\n}/*# sourceMappingURL=features-news.css.map */","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
